import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=257e6710&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=257e6710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e6710",
  null
  
)

export default component.exports